import React, { useContext, useState } from "react";
import PsContext from "../../context";
import Header from "../header";
import CircularList from "./circularList";

const Circular = (props) => {
  const context = useContext(PsContext);

  const [loader, setLoader] = useState(false);

  return (
    <>
      <Header backAction={true} title="Circular" />

      <div className="">
        <div className="container-sm py-md-3">
          <CircularList titleText={"Circular"} />

          <section className="top-space "></section>
        </div>
      </div>
    </>
  );
};
export default Circular;
